'use client'

import MoneyFilledIcon from '@/components/icons/money-filled'
import { Text, type TextProps } from '@/components/ui/text'
import { styled, type HTMLStyledProps } from '@/styled-system/jsx'
import { formatToPrecision } from '@/utils/formatNumber'
import { useTranslations } from 'next-intl'
import { ReactNode, forwardRef } from 'react'

export type CurrencyProps = HTMLStyledProps<'div'> & {
  isProviderGame?: boolean
  amount: number
  alignSymbol?: 'start' | 'end'
  textProps?: TextProps
  symbol?: ReactNode
}

const Currency = forwardRef<HTMLDivElement, CurrencyProps>(function Currency(
  {
    isProviderGame = false,
    amount,
    alignSymbol = 'start',
    symbol = <MoneyFilledIcon color='success' />,
    textProps,
    ...props
  },
  ref
) {
  const t = useTranslations()
  return (
    <styled.div ref={ref} display='inline-flex' alignItems='center' {...props}>
      {alignSymbol === 'start' && symbol}

      <Text as='span' fontVariantNumeric='tabular-nums' truncate {...textProps}>
        {isProviderGame ? t('playing') : formatToPrecision(amount)}
      </Text>

      {alignSymbol === 'end' && symbol}
    </styled.div>
  )
})

export default Currency
